import React, { Component } from 'react'
import { Fragment } from 'react'
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import * as ANT from 'antd';
import InfoCode from './InfoCode'

class CheckPromotion extends Component {

    constructor(props) {
        super(props)
        this.state = {
            code: '',
        }
    }

    componentWillUnmount() {
        this.props.resetDataCheck()
    }

    render() {
        const { t, promotionState } = this.props;
        const { code } = this.state;
        const { isFetchingCheckCode, resultCheckCode, errors } = promotionState

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'checkPromotion'}
                    />
                    <ANT.PageHeader
                        title={t('navigation.checkPromotion')}
                    >
                        <form onSubmit={this.checkPromotion}>
                            <div className="w100-percent flex-center align-center jus">
                                <HMS.FormWrapperInputComponent className="w100-percent mr-2">
                                    <ANT.Input placeholder={t('item.promotions.messCheckCode')} type={`text`}
                                        className={`form-control`}
                                        name={`serialNumber`} onChange={this.onChange}
                                        value={Func.checkUndefine(code)}
                                    />
                                </HMS.FormWrapperInputComponent>
                                <ANT.Button type="primary" loading={isFetchingCheckCode}
                                    onClick={this.checkPromotion}>
                                    {t('item.promotions.btnCheckCode')}
                                </ANT.Button>
                            </div>
                        </form>
                        
                        {
                            resultCheckCode ? 
                                <InfoCode 
                                    data={resultCheckCode}
                                />
                            :
                            <ANT.Empty image={ANT.Empty.PRESENTED_IMAGE_SIMPLE}
                                description={
                                    errors ? <span
                                        className="colorRed">{t(`validation.promotion.${errors.code}`).replace('%s', code)}</span> : t('item.promotions.messCheckCode')
                                } />
                        }
                    </ANT.PageHeader>
                </HMS.PageListComponent>
            </Fragment>
        )
    }

    onChange = (e) => {
        this.setState({ code: e.target.value })
    }

    checkPromotion = (e) => {
        e.preventDefault();
        if(this.state.code.trim()) {
            this.props.checkPromotion(this.state.code)
        }
    }
}

export default CheckPromotion
